import { Box, Button, Container, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import Carousel from "react-material-ui-carousel";
import Aseguradora1 from "../../assets/Home/A1.webp";
import Aseguradora2 from "../../assets/Home/A2.webp";
import Aseguradora3 from "../../assets/Home/A3.webp";

const BrandAseguradoras = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const items = [
    {
      url: Aseguradora1,
    },
    {
      url: Aseguradora2,
    },
    {
      url: Aseguradora3,
    },
  ];

  return (
    <Container sx={{
      display: "flex",
      flexDirection: "column",
      pt: { xs: 2 },
      pb: { xs: 2 },
    }}>
      <Box sx={{ marginTop: "32px" }}>
        <Typography variant="h4" sx={{
          color:"#06C7F9",
          fontSize:{xs:"22px", sm:"26px", md:"32px"},
          textAlign:"center"
        }}>
          Trabajamos en equipo con las mejores aseguradoras{" "}
          <span style={{ color: "#18246B" }}>nacionales e internacionales</span>
        </Typography>

        {/* CAROUSEL */}
        <Carousel
          navButtonsAlwaysVisible={!isMobile}
          sx={{ marginTop: isMobile ? "10px" : "30px" }}
        >
          {items.map((item, i) => (
            <Box
              component="img"
              src={item.url}
              key={i}
              alt="Banner"
              loading="lazy"
              height={isMobile ? "100px" : "200px"}
              sx={{
                width: "100%",
                objectFit: "contain",
              }}
            />
          ))}
        </Carousel>

        <Box
          display="flex"
          justifyContent="center"
          marginTop="15px"
          textAlign="center"
        >
          <Typography variant={isMobile ? undefined : "h6"}>
            ¡Si no encuentras tu aseguradora, comunicate con nosotros!
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" marginTop="15px">
          <Typography
            bgcolor="#194AC1"
            color="white"
            width={isMobile ? 350 : 700}
            borderRadius={2}
            textAlign="center"
            variant={isMobile ? undefined : "h4"}
          >
            Utiliza tu seguro de gastos médicos mayores con nosotros
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" marginTop="10px">
          <Button
            variant="contained"
            component="a" 
            href= "tel:3112119470" 
            startIcon={<PhoneIcon />} 
            sx={{ 
              bgcolor: "#194AC1",
              '&:hover': {
                bgcolor: "#15ce21"
              }
            }}
          >
            3112119470 EXT. 174
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default BrandAseguradoras;
